import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins } from '@fortawesome/free-solid-svg-icons'
import styles from './Points.module.scss'
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

const Points = () => {
  const totalPoints = useSelector((state: RootState) => state.totalPoints)
  let rounds = useSelector((state: RootState) => state.totalRounds)
  if (rounds > 5) {
    rounds = 0
  }

  const progress = (rounds / 5) * 100

  return (
    <div className={styles.container}>
      <div className={styles.points}>
        <FontAwesomeIcon icon={faCoins} className={styles.icon} />
        <span>{totalPoints}</span>
      </div>
      <div className={styles.rounds}>
        <CircularProgressbarWithChildren
          value={progress}
          className={styles.progress}
          styles={buildStyles({
            pathColor: '#ef5470',
            trailColor: 'grey',
          })}
        >
          <p className={styles.roundsNumbers}>
            <span>{rounds}</span>/5
          </p>
        </CircularProgressbarWithChildren>
      </div>
    </div>
  )
}

export default Points
